import React from "react";
import styled from "styled-components";
import {
  FastForwardSharp,
  FastRewindSharp,
  PlayArrow,
  Forward10,
  VolumeOff,
  VolumeUp,
  PauseOutlined,
  PictureInPicture,
} from "@material-ui/icons";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const PlayerControls = ({
  playMedia,
  isPlaying,
  isMute,
  playbackRate,
  skipBackward,
  skipForward,
  rollback,
  currentTime,
  duration,
  onSetCurrentTime,
  handleMuteVolume,
  setPlayBackRate,
  playbackRateOptions,
  promptSetCurrentTime,
  pictureInPicture,
  mediaType,
}) => {
  return (
    <>
      <Container>
        <DisplayContainer>
          <ButtonPlayer
            type="button" // ← Prevents form submission / page reload
            value="seek backward by a set interval: alt r"
            title="seek backward by a set interval: alt r"
            onClick={() => rollback()}
          >
            <Forward10 />
          </ButtonPlayer>

          <ButtonPlayer
            type="button"
            value="seek backward: alt j"
            title="seek backward: alt j"
            onClick={() => skipBackward()}
          >
            <FastRewindSharp />
          </ButtonPlayer>

          <ButtonPlayer
            type="button"
            value="Play/Pause: alt k"
            title="Play/Pause: alt k"
            onClick={() => playMedia()}
          >
            {isPlaying ? <PauseOutlined /> : <PlayArrow />}
          </ButtonPlayer>

          <ButtonPlayer
            type="button"
            value="seek forward: alt l"
            title="seek forward: alt l"
            onClick={() => skipForward()}
          >
            <FastForwardSharp />
          </ButtonPlayer>

          <ButtonPlayer
            type="button"
            value="Toggle Sound"
            title="Toggle Sound"
            onClick={() => handleMuteVolume()}
          >
            {isMute ? <VolumeOff /> : <VolumeUp />}
          </ButtonPlayer>

          {"pictureInPictureEnabled" in document && mediaType === "video" ? (
            <ButtonPlayer
              type="button"
              value="Picture-in-picture"
              title="Picture-in-picture"
              onClick={() => pictureInPicture()}
            >
              <PictureInPicture />
            </ButtonPlayer>
          ) : null}
        </DisplayContainer>
      </Container>
    </>
  );
};

export default PlayerControls;

const Container = styled.div`
  display: inline-block;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
`;

const DisplayContainer = styled.div`
  display: flex;
  border-radius: 5px;
  width: 100%;

  @media ${theme.breakpoints.sm_down} {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 3px;
  }
`;

const ButtonPlayer = styled.button.attrs({ type: "button" })`
  width: 38px;
  height: 38px;
  border-radius: 4px;
  padding: 0.5em;
  border: 0;
  color: white;
  background: ${COLORS.BTN_GREEN};
  font-size: 1em;
  cursor: pointer;
  margin-right: 0.3rem;
  margin-top: 0.3rem;

  &:hover {
    background: ${COLORS.BTN_GREEN};
  }
`;

export const TimeBoxs = styled.div`
  display: inline-block;
  text-align: center;
  border-radius: 5px;
  line-height: 38px;
  padding: 0 2em;
  margin-right: 0.3rem;
  margin-top: 0.2rem;
  background-color: ${COLORS.INPUT_GRAY};

  @media ${theme?.breakpoints?.sm_down} {
    width: 100%;
  }
`;
